import { fg } from '@atlassian/jira-feature-gating';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const GUEST_AWARENESS_STORAGE_NAMESPACE = 'jira-guest-awareness';
const GUEST_AWARENESS_DISMISSED_VALUE = false;

const getProjectKeyFromUrl = (): string | null => {
	const match = /\/projects\/([^/]+)/.exec(
		typeof window !== 'undefined' ? window.location.pathname : '',
	);
	return match?.[1] ?? null;
};

const guestAwarenessStorage = createLocalStorageProvider(GUEST_AWARENESS_STORAGE_NAMESPACE);

const hasGuestFlagBeenDismissed = (projectKey: string): boolean =>
	guestAwarenessStorage.get(projectKey) === GUEST_AWARENESS_DISMISSED_VALUE;

const JiraExternalGuestsSpaceFlagRelayprovider = {
	get(): boolean {
		if (!fg('jira_external_guests_space_flag')) {
			return false;
		}
		if (fg('jira-guest-flag-cache')) {
			const projectKey = getProjectKeyFromUrl();
			if (projectKey !== null && hasGuestFlagBeenDismissed(projectKey)) {
				return false;
			}
		}
		return true;
	},
};

export default JiraExternalGuestsSpaceFlagRelayprovider;
